<div class="root-checkout-container">

  <div *ngIf="isTrial && status!=='error' && showTrialHeadsUpBanner" class="trial-heads-up-wrapper">
    <div class="trial-heads-up-container">
      <mat-icon class="message-info-icon" fontSet="material-icons-two-tone">info</mat-icon>
      <span class="trial-heads-up">{{ expiresTrial }}</span>
    </div>
    <mat-divider class="mat-border-v2"></mat-divider>
  </div>

  <div class="loader-overlay" *ngIf="status === 'loading' && withOverlayLoader">
    <mat-spinner class="absolute-centered" diameter="50"></mat-spinner>
  </div>

  <button mat-icon-button mat-dialog-close class="close-btn close-btn-v2"
    [ngClass]="{'close-btn-heads-up': (isTrial && status!=='error' && showTrialHeadsUpBanner)}"
    aria-label="close checkout dialog" [trackClick]="{page: 'Clicked X Button'}">
    <mat-icon>close</mat-icon>
  </button>

  <div class="inline-checkout-wrapper" *ngIf="status !== 'error'; else errorState">
    <div *ngIf="!dialogData.paymentFailureSummaryData; else paymentFailureSummary" class="billing-details-wrapper version-two-dialogue">
      <app-billing-details (appOutsideClick)="onOutsideClick($event)">
        <p description>{{'billing.reviewBillingDetails' | translate}}</p>
        <p info-banner *ngIf="isTrial">
          {{ 'billing.reviewBillingDetailsInfoBanner' | translate:{ date: (currentPlan?.subscription?.trialEndDate | date:'MMM d, yyyy') } }}
        </p>
        <!-- Plan Name V2-->
        <div billing-detail-item class="row-item-details">
          <div class="title-content">
            <span class="row-section-title">{{'billing.plan' | translate}}</span>
          </div>
          <app-bill-details-row
            [label]="currentPlan?.productId ? ('billing.' + currentPlan.productId | lowercase| translate) : ''"
            [content]="planPriceDescription"
            [price]="formatLocalizedPrice(totalPlanCostWithoutAddonsAndDiscounts)">
          </app-bill-details-row>
        </div>

        <mat-divider class="mat-border-v2"></mat-divider>

        <!-- Addons V2-->
        <div billing-detail-item *ngIf="currentPlan.paymentModel.hasAddons" class="row-item-details">
          <div class="title-content">
            <span class="row-section-title">{{'billing.addOns' | translate}}</span>
            <mat-icon class="info-icon" [matTooltip]="'billing.addOnsTooltip' | translate" matTooltipPosition="after"
              (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" data-html2canvas-ignore
              [matTooltipClass]="'custom-tooltip'">
              info_outline
            </mat-icon>
          </div>
          <div *ngFor="let item of addons; let i = index">
            <app-bill-details-row
              [label]="item.name | translate"
              [content]="item.shortDescription"
              [price]="formatLocalizedPrice(item.totalPrice)">
            </app-bill-details-row>
          </div>
        </div>


        <mat-divider class="mat-border-v2"></mat-divider>

        <!-- Others V2 -->
        <div billing-detail-item class="row-item-details" *ngIf="hasOtherItems">
          <div class="title-content">
            <span class="row-section-title">{{'billing.competitors.other' | translate}}</span>
          </div>
          <div>
            <!-- Tax/VAT V2-->
            <span *ngIf="status !== 'updating'; else contentLoader">
              <app-bill-details-row *ngIf="taxAmount > 0" [label]="removeSpaces('billing.tax' | translate)" [price]="formatLocalizedPrice(taxAmount)">
              </app-bill-details-row>
            </span>
            <!-- Discount V2-->
            <span *ngIf="status !== 'updating'; else contentLoader">
              <app-bill-details-row *ngIf="!!normalizedPromotionalDiscount" [label]="('billing.disc' | translate )" [content]=""
                [badge]="promotionalDiscountBadge"
                [price]="formatLocalizedPrice(normalizedPromotionalDiscount * -1)">
              </app-bill-details-row>
            </span>
            <!--Annual Discount V2 (same as V1)-->
            <span *ngIf="status !== 'updating'; else contentLoader">
              <app-bill-details-row *ngIf="!!annualBillingDiscount" [label]="('billing.annualDiscount' | translate)"
                [content]="" [price]="formatLocalizedPrice(annualBillingDiscount * -1)">
              </app-bill-details-row>
            </span>
          </div>
        </div>

        <mat-divider class="mat-border-v2"></mat-divider>

        <!-- Total bill price V2-->
        <div billing-detail-item class="total-bill-price row-item-details">
          <span class="total-bill-price-text default-label" *ngIf="status !== 'updating'; else contentLoader">
            {{totalBillInfo}}
          </span>
        </div>

        <p neutral-banner *ngIf="!!normalizedPromotionalDiscount">
          {{ 'billing.discountTiedToPlanBanner' | translate }}
        </p>

        <div footer-content *ngIf="dialogData?.socialProof" style="padding-top: 58px;">
          <app-billing-logos-section [opacity]="'1'" [logos]="companyLogos" alignment="start center" billing-detail-item
            [applySocialProofClass]="false">
          </app-billing-logos-section>
        </div>
      </app-billing-details>
    </div>

    <!-- Paddle Section -->
    <div class="checkout-column">
      <nav>
        <button [class.enabled]="isPaddleUpdated" [trackClick]="{page: 'Clicked Personal info'}" class="breadcrumb"
          (click)="breadcrumbClick()">
          <span [class.enabled]="isPaddleUpdated" class="breadcrumb-text">
            {{ 'billing.checkoutDialog.breadcrumb.personalInfo' | translate }}
          </span>
        </button>
        <ng-container *ngIf="isPaddleUpdated">
          <button class="breadcrumb">
            <span class="breadcrumb-text">{{ 'billing.checkoutDialog.breadcrumb.paymentInfo' | translate }}</span>
          </button>
        </ng-container>
      </nav>

      <!-- Here goes the Paddle checkout iframe -->
      <div class="inline-checkout-container" [attr.data-sandbox]="paymentProvider.isSandbox"></div>
    </div>
  </div>
</div>

<!-- Templates -->
<ng-template #errorState>
  <app-empty-state [icon]="'error'">
    <h3 title>{{ (isUnsupportedCountry ? 'billing.checkoutDialog.unsupportedCountry.title' : 'billing.checkoutDialog.loadError.title') | translate }}</h3>
    <div description [ngClass]="{'unsupported-country': isUnsupportedCountry}"
      [innerHTML]="(isUnsupportedCountry ? 'billing.checkoutDialog.unsupportedCountry.description' : 'billing.checkoutDialog.loadError.description') | translate">
    </div>
  </app-empty-state>
</ng-template>

<ng-template #paymentFailureSummary>
  <app-payment-summary [inputData]="dialogData.paymentFailureSummaryData"></app-payment-summary>
</ng-template>

<ng-template #contentLoader>
  <mat-spinner diameter="18" content></mat-spinner>
</ng-template>
